import supabaseClient from '@/api/supabaseClient.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type UpdateVerificationParams = {
  user_id: string;
  is_verified: boolean;
};

const useUpdateVerification = () => {
  const queryClient = useQueryClient();

  const mutationFn = async ({ user_id, is_verified }: UpdateVerificationParams) => {
    const { data, error } = await supabaseClient
      .from('users')
      .update({ is_verified })
      .eq('id', user_id)
      .select()
      .single();

    if (error) {
      console.error('Error updating verification:', error);
      throw new Error(error.message);
    }

    const documentStatus = is_verified ? 'verified' : 'rejected';
    const { error: docError } = await supabaseClient.functions.invoke('admin_update_documents_status', {
      method: 'POST',
      body: { user_id, status: documentStatus },
    });

    if (docError) {
      console.error('Error updating document statuses:', docError);
    }

    return data;
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-verification-requests'] });
      queryClient.invalidateQueries({ queryKey: ['admin-carers'] });
      queryClient.invalidateQueries({ queryKey: ['documents'] });
    },
  });
};

export default useUpdateVerification;
